(function () {
    const content = document.querySelector('.post-template [data-article-content]');
    const toc = document.querySelector('[data-article-toc]');
    const tocList = toc && toc.querySelector('.cy-article-toc-list');
    const jump = document.querySelector('[data-article-jump]');
    const tocToggle = jump && jump.querySelector('[data-article-toc-toggle]');
    const topButton = jump && jump.querySelector('[data-article-top]');
    const bottomButton = jump && jump.querySelector('[data-article-bottom]');

    if (!content || !toc || !tocList || !jump || !tocToggle || !topButton || !bottomButton) {
        return;
    }

    const headings = Array.from(content.querySelectorAll(':scope > h2, :scope > h3'));
    const links = [];

    headings.forEach(function (heading, index) {
        if (!heading.id) {
            heading.id = 'section-' + (index + 1);
        }

        const item = document.createElement('li');
        item.className = 'cy-article-toc-item is-level-' + heading.tagName.slice(1);

        const link = document.createElement('a');
        link.className = 'cy-article-toc-link';
        link.href = '#' + encodeURIComponent(heading.id);
        link.textContent = heading.textContent.trim();
        link.addEventListener('click', function (event) {
            event.preventDefault();
            toc.classList.remove('is-mobile-open');
            tocToggle.setAttribute('aria-expanded', 'false');
            heading.scrollIntoView({behavior: 'smooth', block: 'start'});
            history.replaceState(null, '', '#' + encodeURIComponent(heading.id));
        });

        item.appendChild(link);
        tocList.appendChild(item);
        links.push(link);
    });

    if (headings.length) {
        toc.hidden = false;
    }
    jump.hidden = false;

    tocToggle.addEventListener('click', function () {
        const isOpen = toc.classList.toggle('is-mobile-open');
        tocToggle.setAttribute('aria-expanded', String(isOpen));
        tocToggle.setAttribute('aria-label', isOpen ? '关闭本文目录' : '打开本文目录');
    });

    topButton.addEventListener('click', function () {
        const contentTop = content.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({top: Math.max(0, contentTop - 96), behavior: 'auto'});
    });

    bottomButton.addEventListener('click', function () {
        const contentBottom = content.getBoundingClientRect().bottom + window.scrollY;
        const target = contentBottom - window.innerHeight + 72;
        window.scrollTo({top: Math.max(0, target), behavior: 'auto'});
    });

    let ticking = false;
    function updateTools() {
        const rect = content.getBoundingClientRect();
        const withinContent = rect.top <= 112 && rect.bottom >= window.innerHeight - 72;

        toc.classList.toggle('is-visible', withinContent && headings.length > 0);
        jump.classList.toggle('is-visible', withinContent);
        toc.setAttribute('aria-hidden', String(!withinContent || !headings.length));
        jump.setAttribute('aria-hidden', String(!withinContent));

        if (!withinContent) {
            toc.classList.remove('is-mobile-open');
            tocToggle.setAttribute('aria-expanded', 'false');
        }

        if (withinContent && headings.length) {
            let currentIndex = 0;
            headings.forEach(function (heading, index) {
                if (heading.getBoundingClientRect().top <= 132) {
                    currentIndex = index;
                }
            });

            links.forEach(function (link, index) {
                const isCurrent = index === currentIndex;
                link.classList.toggle('is-current', isCurrent);
                if (isCurrent) {
                    link.setAttribute('aria-current', 'location');
                    const linkTop = link.offsetTop;
                    const linkBottom = linkTop + link.offsetHeight;
                    if (linkTop < toc.scrollTop) {
                        toc.scrollTop = Math.max(0, linkTop - 10);
                    } else if (linkBottom > toc.scrollTop + toc.clientHeight) {
                        toc.scrollTop = linkBottom - toc.clientHeight + 10;
                    }
                } else {
                    link.removeAttribute('aria-current');
                }
            });
        }

        ticking = false;
    }

    function requestUpdate() {
        if (!ticking) {
            window.requestAnimationFrame(updateTools);
            ticking = true;
        }
    }

    window.addEventListener('scroll', requestUpdate, {passive: true});
    window.addEventListener('resize', requestUpdate);
    requestUpdate();
})();
